module.exports = __webpack_public_path__ + "img/goodStyle-2.3099fbed.jpg";